<button (click)="onClickEdit()" class="btn-edit-employee" mat-button [routerLink]="'/my-account/edit-employee'">
  <mat-icon
    class="material-icons-sharp light add-employee"
    matTooltip="{{ 'buttonTooltip.myAccount.editEntry' | cxTranslate }}"
    [matTooltipPosition]="'below'"
    matTooltipClass="icon-tooltip"
    aria-label="displays a tooltip in bottom"
    [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
    >create</mat-icon
  >
</button>
